module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_gujarati.a7145056.mp3";